import { Checkbox, Tooltip } from "@mui/material";
import { useExcludeChecklistMutation } from "app/api/orders";
import { Checklist } from "models/Checklist";

type ExcludeChecklistProps = {
  checklist: Checklist;
};

const ExcludeChecklist: React.FC<ExcludeChecklistProps> = ({ checklist }) => {
  const [excludeChecklist] = useExcludeChecklistMutation();

  const toggleVisibility = () => {
    if (!checklist.id) return;

    excludeChecklist({
      orderId: checklist.partOfOrder,
      checklistId: checklist.id,
      excludedFromReport: !checklist?.excludedFromReport,
    });
  };

  return (
    <Tooltip
      title={
        checklist?.excludedFromReport
          ? "Inkludera checklistan på slutrapport"
          : "Exkludera checklistan från slutrapport"
      }
    >
      <Checkbox
        checked={!checklist?.excludedFromReport}
        onChange={toggleVisibility}
        sx={{ fontSize: 24, p: "5px" }} // Same size as "small" IconButton
      />
    </Tooltip>
  );
};

export default ExcludeChecklist;
